'use client';

import React__default from 'react';

var LocationIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? '#50596E' : _d;
    return (React__default.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("circle", { cx: width / 2, cy: height / 2, r: "11.5", fill: "#F4F4F7", stroke: "white" }),
        React__default.createElement("path", { d: "M12.0002 6.24023C9.88328 6.24023 8.16016 7.96336 8.16016 10.0802C8.16016 13.4674 11.6711 17.5071 11.8202 17.6777C11.8661 17.7302 11.9308 17.7602 12.0002 17.7602C12.0742 17.7555 12.1342 17.7302 12.1802 17.6777C12.3292 17.5043 15.8402 13.3952 15.8402 10.0802C15.8402 7.96336 14.117 6.24023 12.0002 6.24023ZM12.0002 8.88023C12.7952 8.88023 13.4402 9.52523 13.4402 10.3202C13.4402 11.1152 12.7952 11.7602 12.0002 11.7602C11.2052 11.7602 10.5602 11.1152 10.5602 10.3202C10.5602 9.52523 11.2052 8.88023 12.0002 8.88023Z", fill: color })));
};
var LocationIcon$1 = /*#__PURE__*/ React__default.memo(LocationIcon);

export { LocationIcon$1 as default };
//# sourceMappingURL=index.js.map
